import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './chapter-detail.scss';
import UnitDetail from '../unit-detail/unit-detail';

const ChapterDetail = ({ title, units, documentUrl, titleClassName, unitClassName }) => {
    let html = '';
    if (units.length > 0) {
        if (documentUrl === '') {
            html = (<p><a className={titleClassName}>{title}</a></p>);
        } else {
            html = (<p><a href={documentUrl} target="_blank" className={titleClassName}>{title}</a></p>);
        }
    } else if (documentUrl !== '') {
        html = (<p><a href={documentUrl} target="_blank" className={titleClassName}>{title}</a></p>);
    }

    return (
        <div className={css.component}> { html }
        {
            _.map(units, unit =>
                <UnitDetail key={unit.id + unit.title} title={unit.title} documentUrl={unit.documentUrl} unitClassName={unitClassName} />
            )
        }
    </div>);
};

ChapterDetail.propTypes = {
    title: PropTypes.string,
    units: PropTypes.array,
    documentUrl: PropTypes.string,
    titleClassName: PropTypes.string,
    unitClassName: PropTypes.string
};

export default ChapterDetail;
